import(/* webpackMode: "eager" */ "/home/janab/freelance/alfamall/comverse-baseapp-next/app/(alfamall)/login/page.jsx");
